export default __webpack_public_path__ + "static/media/chevron-right.inline.937fe86b.svg";